var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "material-return-list" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "demo-form-inline",
          attrs: { model: _vm.form, size: "small", inline: "" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "物料退还单", prop: "code" } },
            [
              _c("el-input", {
                staticClass: "input__width",
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.form.code,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "code", $$v)
                  },
                  expression: "form.code",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "退还人", prop: "refund_user_id" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    remote: "",
                    "remote-method": _vm.searchReceiver,
                    loading: _vm.personLoading,
                    "no-data-text": "无数据",
                    placeholder: "请选择",
                  },
                  on: {
                    clear: function ($event) {
                      return _vm.searchReceiver("")
                    },
                  },
                  model: {
                    value: _vm.form.refund_user_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "refund_user_id", $$v)
                    },
                    expression: "form.refund_user_id",
                  },
                },
                _vm._l(_vm.personOptions.receiver || [], function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: _vm.formatPersonLabel(item),
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "退还部门", prop: "organize_id" } },
            [
              _c("el-cascader", {
                ref: "organize",
                staticClass: "input__width",
                attrs: {
                  options: _vm.options,
                  "collapse-tags": "",
                  props: {
                    label: "label",
                    value: "value",
                    children: "children",
                    multiple: true,
                    emitPath: false,
                  },
                  clearable: "",
                  placeholder: "请选择",
                },
                model: {
                  value: _vm.form.organize_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "organize_id", $$v)
                  },
                  expression: "form.organize_id",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物料编码", prop: "material_id" } },
            [
              _c("el-input", {
                staticClass: "input__width",
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.form.material_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "material_id", $$v)
                  },
                  expression: "form.material_id",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物料名称", prop: "name" } },
            [
              _c("el-input", {
                staticClass: "input__width",
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物料类型", prop: "material_type" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", multiple: "", clearable: "" },
                  model: {
                    value: _vm.form.material_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "material_type", $$v)
                    },
                    expression: "form.material_type",
                  },
                },
                _vm._l(_vm.materialTypeList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { value: item.value, label: item.label },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "印刷类型", prop: "print_type" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.print_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "print_type", $$v)
                    },
                    expression: "form.print_type",
                  },
                },
                [
                  _c("el-option", { attrs: { value: "1", label: "标准版" } }),
                  _c("el-option", { attrs: { value: "2", label: "个性化" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "领用申请单", prop: "receive_code" } },
            [
              _c("el-input", {
                staticClass: "input__width",
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.form.receive_code,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "receive_code", $$v)
                  },
                  expression: "form.receive_code",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "操作人", prop: "updated_by" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    remote: "",
                    "remote-method": _vm.searchOperator,
                    loading: _vm.personLoading,
                    "no-data-text": "无数据",
                    placeholder: "请选择",
                  },
                  on: {
                    clear: function ($event) {
                      return _vm.searchOperator("")
                    },
                  },
                  model: {
                    value: _vm.form.updated_by,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "updated_by", $$v)
                    },
                    expression: "form.updated_by",
                  },
                },
                _vm._l(_vm.personOptions.operator || [], function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: _vm.formatPersonLabel(item),
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "退还时间", prop: "refund_time" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  "value-format": "yyyy-MM-dd",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                model: {
                  value: _vm.form.refund_time,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "refund_time", $$v)
                  },
                  expression: "form.refund_time",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.search },
                },
                [_vm._v("搜索")]
              ),
              _vm.$hasBtnRoles("/material/order/other-refund-refund")
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.handlereturn },
                    },
                    [_vm._v("退还")]
                  )
                : _vm._e(),
              _vm.$hasBtnRoles("/material/order/other-refund-export")
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "warning" },
                      on: { click: _vm.handleExport },
                    },
                    [_vm._v("导出")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-top": "10px" },
          attrs: {
            border: "",
            "header-cell-style": { background: "#F1F1F1", color: "#333333" },
            data: _vm.dataList,
            "row-key": function (row) {
              return row._rowKey
            },
            "span-method": _vm.objectSpanMethod,
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "物料退还单",
              prop: "code",
              align: "left",
              width: "120px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "创建时间",
              prop: "created_at",
              align: "left",
              width: "150px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "退还人",
              prop: "refund_user_name",
              align: "left",
              width: "100px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "退还部门",
              prop: "organize_name",
              align: "left",
              width: "110px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "退还日期",
              prop: "refund_date",
              align: "left",
              width: "130px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "备注",
              "min-width": "200px",
              prop: "remark",
              align: "left",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.remark || "-") + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作人",
              prop: "updated_user_name",
              align: "left",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "领用申请单",
              prop: "receive_code",
              align: "left",
              width: "110px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "物料编码",
              prop: "material_id",
              align: "left",
              width: "110px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "物料预览图",
              width: "120px",
              prop: "pre_img",
              align: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.pre_img
                      ? _c("el-image", {
                          staticStyle: { height: "50px", width: "70px" },
                          attrs: {
                            src: scope.row.pre_img,
                            "preview-src-list": [scope.row.pre_img],
                            fit: "contain",
                          },
                        })
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "物料名称",
              "min-width": "150px",
              prop: "name",
              align: "left",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "物料类型",
              prop: "material_type_des",
              align: "left",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "工艺材质", prop: "craft_type_des", align: "left" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "规格",
              prop: "attribute_str",
              align: "left",
              width: "110px",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "印刷类型", prop: "print_type_des", align: "left" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "退还仓库",
              prop: "branch_office_name",
              align: "left",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "退还数量",
              prop: "refund_num",
              align: "left",
              width: "120px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "80px",
              align: "left",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleView(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "right", margin: "20px 0" } },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "page-size": 20,
              "page-sizes": [20, 50, 100, 200],
              total: _vm.pages.totalCount,
              "current-page": _vm.pages.page,
            },
            on: {
              "current-change": _vm.currentChange,
              "size-change": _vm.sizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawerReturn,
            size: "88%",
            "custom-class": "myDrawer",
            title: "其他物料退还",
            "append-to-body": "",
            "destroy-on-close": "",
            "wrapper-closable": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerReturn = $event
            },
          },
        },
        [
          _c("material-return-apply-drawer", {
            attrs: { id: _vm.currentReturnId },
            on: {
              close: function ($event) {
                _vm.drawerReturn = false
              },
              emitGetList: _vm.handleReturnEmitGetList,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawerView,
            size: "88%",
            "custom-class": "myDrawer",
            title: "其他物料退还详情",
            "append-to-body": "",
            "destroy-on-close": "",
            "wrapper-closable": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerView = $event
            },
          },
        },
        [
          _c("material-return-view-drawer", {
            key: _vm.currentRowId,
            attrs: { id: _vm.currentRowId },
            on: {
              close: function ($event) {
                _vm.drawerView = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }